<ng-container *ngIf="!!get && !!params">
    <tt-tabs *ngIf="get.show_gb_orderline_displaytype === '1'" ttRememberId="ohPackery.bgOrderLineDisplayType" [(ttSelectedId)]="displayType" (ttSelectedIdChange)="onDisplayTypeChanged()">
        <tt-tab ttId="std" ttLabel="gb_orderline_displaytype_std"></tt-tab>
        <tt-tab ttId="change" ttLabel="gb_orderline_displaytype_changeprovidemethod"></tt-tab>
    </tt-tabs>

    <ng-container *ngIf="displayType === 'change'">
        <tt-button-goto
            class="order-head-order-lines__change-button"
            ttText="orderhead_relatedpurchorders"
            ttGoto="relatedpurchorders"
            [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: get.order_internal_no }"
            ttTextAlign="left"
        ></tt-button-goto>

        <tt-list-legacy
            *ngIf="get.setting_orderlines_use_grid === '0'"
            class="order-head-order-lines__legacy-list"
            [listItems]="orderLines"
            ltype="multi"
            [designVar]="'s12'"
            [optionfunc]="toggleChosen"
            [ttChange]="onOrderlineChanged"
        ></tt-list-legacy>

        <tt-grid
            *ngIf="get.setting_orderlines_use_grid === '1' && !!changeGrid"
            class="order-head-order-lines__grid"
            [(ttOptions)]="changeGrid"
            ttRowSelection="single"
            (ttOnRowSelected)="onChangeOrderlineRowSelected($event)"
        ></tt-grid>
    </ng-container>

    <div *ngIf="displayType === 'std'" class="order-head-order-lines__content order-head-order-lines__content--std">
        <tt-list-legacy
            *ngIf="get.setting_orderlines_use_grid === '0'"
            class="order-head-order-lines__legacy-list"
            [listItems]="orderLines"
            ltype="multi"
            [mconfig]="mconfig"
            typevar="g"
            [designVar]="'s12'"
            [ttChange]="onOrderlineChanged"
        ></tt-list-legacy>

        <div *ngIf="get.setting_orderlines_use_grid === '1'" class="order-head-order-lines__grid-wrap">
            <tt-order-lines-grid
                *ngIf="get.setting_orderlines_use_dynamic_grid === '1'"
                [params]="params"
                rowSelection="single"
                (gridReady)="onDynamicGridReady($event)"
                (rowSelected)="onOrderlineRowSelected($event)"
            ></tt-order-lines-grid>

            <tt-grid
                *ngIf="get.setting_orderlines_use_dynamic_grid === '0' && get.setting_orderlines_use_new_grid === '1' && !!oldGrid"
                class="order-head-order-lines__grid"
                [(ttOptions)]="oldGrid"
                ttRowSelection="single"
                (ttOnRowSelected)="onOrderlineRowSelected($event)"
            ></tt-grid>

            <tt-grid
                *ngIf="get.setting_orderlines_use_dynamic_grid === '0' && get.setting_orderlines_use_new_grid === '0' && !!standardGrid"
                class="order-head-order-lines__grid"
                [(ttOptions)]="standardGrid"
                ttRowSelection="single"
                (ttOnRowSelected)="onOrderlineRowSelected($event)"
            ></tt-grid>
        </div>

        <tt-card
            *ngIf="get.show_buttons_below_grid === '1' || get.setting_show_orderline_calculation === '1'"
            [ttHeading]="get.setting_show_orderline_calculation === '1' ? 'calc' : 'orderline_functions'"
            ttTranslateHeading
            ttAccordion
            ttRememberId="w_orderhead.card.orderline_functions"
        >
            <tt-order-head-order-line-calculation
                *ngIf="get.setting_show_orderline_calculation === '1'"
                [orderlineKeyno]="selectedOrderlineKeyno"
                [refreshToken]="calculationRefreshToken"
            ></tt-order-head-order-line-calculation>

            <hr *ngIf="get.show_buttons_below_grid === '1' && get.setting_show_orderline_calculation === '1'" class="k-hr col-xs-12 sp-0" />
            <ng-container *ngIf="get.show_buttons_below_grid === '1'">
                <tt-button-goto
                    *ngIf="get.show_add_orderline === '1' && get.show_depraceted_buttons === '1'"
                    ttText="orderhead_orderline_new"
                    ttIcon="far fa-plus"
                    (ttClick)="openNewOrderLine($event)"
                ></tt-button-goto>
                <tt-button-goto *ngIf="get.show_orderline_textile === '1'" ttText="orderhead_new_orderline_textile" ttIcon="far fa-plus" (ttClick)="openNewTextileOrderLine($event)"></tt-button-goto>
                <tt-button-goto
                    *ngIf="get.show_button_setnewdiscount === '1'"
                    ttText="orderhead_setnewdiscount"
                    ttGoto="orderheadsetdisc"
                    [ttGotoParms]="{ order_internal_no: get.order_internal_no }"
                ></tt-button-goto>
                <tt-button *ngIf="get.edi_orderhead_keyno > '0'" ttText="edi_order" (ttClick)="openEdiOrder($event)"></tt-button>
                <tt-button-goto
                    *ngIf="get.show_button_errorcheck_and_generate_bom === '1'"
                    ttText="orderhead_errorcheck_and_generate_bom"
                    ttIcon="far fa-sync-alt"
                    [ttLoading]="generatingErrorCheck"
                    (ttClick)="generateCheck()"
                ></tt-button-goto>

                <tt-button-goto
                    *ngIf="get.show_positions === '1'"
                    ttText="orderhead_positions"
                    [ttBadge]="get.nbr_of_positions"
                    ttGoto="positions"
                    [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: get.order_internal_no }"
                ></tt-button-goto>
                <tt-button-goto
                    *ngIf="get.show_button_deleteorderlines === '1' && get.show_depraceted_buttons === '1'"
                    ttText="orderhead_deleteorderlines"
                    ttGoto="orderheaddeleteol"
                    [ttGotoParms]="{ order_internal_no: get.order_internal_no }"
                ></tt-button-goto>
                <tt-button-goto
                    *ngIf="get.show_direct_order_delivery === '1'"
                    ttText="orderhead_direct_order_delivery"
                    ttGoto="ohdirectdelivery"
                    [ttGotoParms]="{ order_internal_no: get.order_internal_no }"
                ></tt-button-goto>
                <tt-button-goto
                    *ngIf="get.show_customer_service === '1'"
                    ttText="orderhead_customer_service"
                    ttGoto="ordercustomerservice"
                    [ttGotoParms]="{ order_internal_no: get.order_internal_no }"
                ></tt-button-goto>
                <tt-button-goto
                    *ngIf="isPrepaymentVisible()"
                    ttText="orderhead_register_prepayment"
                    ttType="danger"
                    ttIcon="fa fa-solid fa-plus"
                    ttIconPullRight
                    ttGoto="prepayment"
                    [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: get.order_internal_no, prepayment_keyno: '0' }"
                ></tt-button-goto>
                <tt-button-goto
                    *ngIf="get.show_button_add_orderline_from_pricelist === '1'"
                    ttText="add_products_from_pricelist"
                    ttIcon="far fa-plus"
                    [ttLoading]="addingProductsFromPricelist"
                    (ttClick)="addProductsFromPricelist()"
                ></tt-button-goto>
                <tt-button-goto
                    *ngIf="get.show_button_remove_zero_qty_orderlines === '1'"
                    ttText="remove_zero_qty_lines"
                    ttIcon="fad fa-trash"
                    [ttLoading]="removingZeroQuantityLines"
                    (ttClick)="removeZeroQuantityLines()"
                ></tt-button-goto>
                <tt-button-goto
                    *ngIf="get.show_jobcalc === '1'"
                    ttText="orderhead_jobcalcs"
                    ttIcon="far fa-plus"
                    ttGoto="orderheadcalcs"
                    [ttGotoParms]="{ order_internal_no: get.order_internal_no }"
                ></tt-button-goto>
                <tt-button-goto
                    *ngIf="get.show_btn_orderhead_price_update === '1'"
                    ttText="orderhead_price_update"
                    ttIcon="far fa-sync-alt"
                    [ttLoading]="updatingOrderPrices"
                    (ttClick)="updateOrderPrices()"
                ></tt-button-goto>
            </ng-container>
        </tt-card>
    </div>
</ng-container>
